import { useQuery, gql } from "@apollo/client"

const GROUP_FIELDS = `
  id
  name
  attributes {
    id
    location
    integration
    key
    value
  }
`

const GROUPS_QUERY = gql`
  query {
    groups {
      ${GROUP_FIELDS}
    }
  }
`

const useQueryGroups = () => useQuery(GROUPS_QUERY)

export { useQueryGroups, GROUP_FIELDS }
